import styles from './DateInput.module.scss';

import { Icon, IconButton, Input } from '../../../atoms';

import usePresenter from './DateInput.presenter';
import { DateInputProps } from './DateInput.types';
import DatePickerBase from '../DatePickerBase';
import { useCallback } from 'react';

const DateInput = (props: DateInputProps) => {
  const {
    invalid,
    isTimePickerOnly,
    onInputBlur,
    inputLeadingIcon,
    readOnly,
    inputVariantProps,
    handleInputReadOnlyState,
    handleReady,
    handleCalendarIconClick,
  } = usePresenter(props);

  const { ariaLabel, ariaLabelledBy } = props;
  const baseAriaLabel = ariaLabel != null ? ariaLabel : 'Date input';

  const calendarIcon = (
    <IconButton
      size='Small'
      type='Ghost'
      aria-label={`${baseAriaLabel}--open-calendar`}
      icon={<Icon icon='Calendar' size='Small' style='Outlined' />}
      onClick={handleCalendarIconClick}
    />
  );

  const renderInput = useCallback(
    (_: any, ref: (node: HTMLInputElement | null) => void) => {
      return (
        <Input
          ref={ref}
          className={styles.dateInput}
          inputType='Text'
          invalid={invalid}
          onBlur={isTimePickerOnly ? onInputBlur : undefined}
          leadingIcon={props.leadingIcon || inputLeadingIcon}
          trailingIcon={props.trailingIcon || calendarIcon}
          readOnly={readOnly}
          autoComplete='off'
          placeholder={props.placeholder}
          id={props.id}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          {...inputVariantProps}
        />
      );
    },
    [invalid, isTimePickerOnly, onInputBlur, props.leadingIcon, props.trailingIcon, props.placeholder, props.id, ariaLabel, ariaLabelledBy, inputLeadingIcon, calendarIcon, readOnly, inputVariantProps]
  );

  return (
    <DatePickerBase
      {...props}
      onReady={handleReady}
      renderInput={renderInput}
      handleInputReadOnlyState={handleInputReadOnlyState}
    />
  );
};

export default DateInput;
